import { render, staticRenderFns } from "./ChainSelect.vue?vue&type=template&id=964f6ec6&scoped=true"
import script from "./ChainSelect.vue?vue&type=script&lang=js"
export * from "./ChainSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "964f6ec6",
  null
  
)

export default component.exports